import { render, staticRenderFns } from "./BudgetStats.vue?vue&type=template&id=55b09a49&scoped=true&"
import script from "./BudgetStats.vue?vue&type=script&lang=js&"
export * from "./BudgetStats.vue?vue&type=script&lang=js&"
import style0 from "./BudgetStats.vue?vue&type=style&index=0&id=55b09a49&prod&scoped=true&lang=css&"
import style1 from "./BudgetStats.vue?vue&type=style&index=1&id=55b09a49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b09a49",
  null
  
)

export default component.exports